import clsx from 'clsx';
import type { ReactNode } from 'react';

import { HeaderBar } from 'src/components/v2/HeaderBar';

import './CommonPagesLayout.scss';

type CommonPagesLayoutProps = {
  fullWidth?: boolean;
  children: ReactNode;
};

export function CommonPagesLayout(props: CommonPagesLayoutProps) {
  const fullWidth = props.fullWidth ?? false;
  const columnClassname = clsx('CommonPagesLayout__content-column', {
    'CommonPagesLayout__content-column--full-width': fullWidth,
  });

  return (
    <div className='CommonPagesLayout'>
      <HeaderBar />
      <div className='CommonPagesLayout__content'>
        <main className={columnClassname}>{props.children}</main>
      </div>
    </div>
  );
}
